export const scrollPreviewFieldIntoView = (container, fieldKey) => {
  if (!container || !fieldKey) return false;

  const target = Array.from(
    container.querySelectorAll("[data-preview-field-key]"),
  ).find(
    (element) => element.getAttribute("data-preview-field-key") === fieldKey,
  );

  if (!target) return false;

  const containerRect = container.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();
  const centeredTop =
    container.scrollTop +
    targetRect.top -
    containerRect.top -
    (container.clientHeight - targetRect.height) / 2;

  container.scrollTo({
    top: Math.max(0, centeredTop),
    behavior: "smooth",
  });

  return true;
};
